// @flow
import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { observer } from 'mobx-react'
import safeUrl from '../util/safeUrl';
import { withRouter } from 'react-router';

import helpers from '../util/helpers';

import type { AppStateType } from '../Types';

type ItemProps = {
  value: Object,
  intl: Object,
  history: Object,
  appState: AppStateType
}

const TableOfContentsItem = withRouter(injectIntl(observer(class SummaryTableItem extends Component<ItemProps> {
  navigate() {
    let url = '/' + this.props.value.id.replace('.', '/');
    helpers.eventLog("nav:tableofcontents link clicked -  - " + url);
    this.props.history.push(url);
    window.scrollTo(0, 0);
  }

  render() {
    let chemical = this.props.value.group
    let iconUrl = safeUrl(`/images/${this.props.intl.messages['chemicals.' + helpers.convertGroupName(chemical) + '.icon']}`)
    let hexColor = helpers.getIconColor(helpers.convertGroupName(chemical), this.props.intl)

    return (
      <tr key={this.props.value.id} onTouchEnd={this.navigate.bind(this)} onClick={this.navigate.bind(this)}>
        <td>
          <span className='group-icon' style={{
              mask: `url(${iconUrl})`,
              WebkitMask: `url(${iconUrl})`,
              display: "inline-block",
              background: hexColor,
              WebkitMaskSize: "cover",
              maskSize: "cover",
              width: 35,
              height: 35,
            }}/>
        </td>
        <td>
          <strong><FormattedMessage id={this.props.value.id + ".title"} /></strong>
        </td>
      </tr>
    )
  }
})));

type Props = {
  items: Object[],
  intl: Object,
  history: Object,
  appState: AppStateType
}

class TableOfContents extends Component<Props> {
  goToPersonalSummary() {
    let url = '/summary'
    helpers.eventLog("nav:tableofcontents link clicked -  - " + url);
    this.props.history.push(url);
    window.scrollTo(0, 0);
  }

  goToStudySummary() {
    let url = '/overallstudyresults'
    helpers.eventLog("nav:tableofcontents link clicked -  - " + url);
    this.props.history.push(url);
    window.scrollTo(0, 0);
  }

  render() {
    // let homeUrl = safeUrl(`/images/icon-home.svg`)
    // let return_to_summary = (
    //   <tr key={"summary"} onClick={this.goToSummary.bind(this)}>
    //     <td>
    //       <span className='group-icon' style={{
    //           mask: `url(${homeUrl})`,
    //           WebkitMask: `url(${homeUrl})`,
    //           display: "inline-block",
    //           background: "black",
    //           WebkitMaskSize: "cover",
    //           maskSize: "cover",
    //           width: 35,
    //           height: 35,
    //         }}/>
    //     </td>
    //     <td>
    //       <strong><FormattedMessage id={"app.pages.summary.title"} /></strong>
    //     </td>
    //   </tr>
    //   )
    let return_to_personal_summary = (
      <p className="no-icon-page-link" onClick={this.goToPersonalSummary.bind(this)}>
        <strong><FormattedMessage id={"app.pages.summary.title"} /></strong>
      </p>)
    let return_to_study_summary = (
      <p className="no-icon-page-link" onClick={this.goToStudySummary.bind(this)}>
        <strong><FormattedMessage id={"page.overallstudyresults.title"} /></strong>
      </p>)



    const summary_items = this.props.items
      .map(value => (
        <TableOfContentsItem key={value.id} value={value} appState={this.props.appState}/>
      ));

    return (
      <div>
        {return_to_study_summary}
        {return_to_personal_summary}
        <table className='overview'>
          <tbody>
            {summary_items}
          </tbody>
        </table>
      </div>
    );
  }
}

export default injectIntl(TableOfContents);



// WEBPACK FOOTER //
// ./src/components/TableOfContents.js